import { render } from "./offer.vue?vue&type=template&id=335c5730&scoped=true"
import script from "./offer.vue?vue&type=script&lang=js"
export * from "./offer.vue?vue&type=script&lang=js"

import "./offer.vue?vue&type=style&index=0&id=335c5730&lang=css"
import "./offer.vue?vue&type=style&index=1&id=335c5730&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-335c5730"]])

export default __exports__